import SalesController from '@app/Sales/Controller'
import SalesVariantCard from '@app/Sales/VariantCard'
import SalesCartVariantCard from '@app/Sales/CartVariantCard'

export default function install(Vue) {
  Vue.component('SalesController', SalesController)
  Vue.component('SalesVariantCard', SalesVariantCard)
  Vue.component('SalesCartVariantCard', SalesCartVariantCard)
}
